// Local storage keys
export const LsKeys = {
  // Legacy: la preferencia vivia aca antes de mudarse al perfil. La lee la
  // migracion de loadUserSettings y despues la borra. No escribir en ella.
  paletteType: "paletteType",
  // La eleccion de modo hecha EN ESTE dispositivo. Manda sobre el perfil: el
  // tema responde al entorno —luz, pantalla, hora— y no a la persona, asi que
  // la misma cuenta puede querer claro en el escritorio y oscuro en el
  // telefono. Solo la escribe una accion explicita del usuario.
  themeChoice: "themeChoice",
  // Borrador del banco de diseno. Vive en sessionStorage: es trabajo en
  // curso, no una preferencia.
  themeDraft: "themeDraft",
  // El tema activo traido de /public/theme. Vive en localStorage: a
  // diferencia del borrador, no es trabajo en curso — es lo que el
  // sistema decidio para todos.
  appliedTheme: "appliedTheme",
  signInRedirect: "signInRedirect",
  language: "language",
};
